var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudDatabase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 7.20001C30.7599 7.20001 34.5947 11.8159 35.1525 17.3904L35.3231 17.3904C39.0056 17.3904 42.098 19.9906 42.9605 23.504C42.5526 23.2526 42.1216 23.0356 41.6851 22.8485C39.8007 22.0409 37.3648 21.6 34.8 21.6C32.2352 21.6 29.7992 22.0409 27.9149 22.8485C26.977 23.2504 26.0646 23.7907 25.3519 24.5129C24.629 25.2454 24 26.2914 24 27.6V33.6H12.6769C8.32661 33.6 4.79999 29.9714 4.79999 25.4952C4.79999 21.019 8.32661 17.3904 12.677 17.3904L12.8475 17.3904C13.4085 11.7793 17.24 7.20001 24 7.20001Z",
    fill: "#2A446F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8 24C30.1608 24 26.4 26.149 26.4 28.8C26.4 31.451 30.1608 33.6 34.8 33.6C39.4392 33.6 43.2 31.451 43.2 28.8C43.2 26.149 39.4392 24 34.8 24Z",
    fill: "#0078D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9304 34.2779C39.9859 35.389 37.4599 36 34.8 36C32.1401 36 29.614 35.389 27.6696 34.2779C27.2348 34.0295 26.8045 33.7395 26.4 33.4086V40.8C26.4 43.451 30.1608 45.6 34.8 45.6C39.4392 45.6 43.2 43.451 43.2 40.8V33.4086C42.7955 33.7395 42.3652 34.0295 41.9304 34.2779Z",
    fill: "#0078D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudDatabase);
export default __webpack_public_path__ + "static/media/Cloud_Database.529331a0034dab902689de952f134bd4.svg";
export { ForwardRef as ReactComponent };